import React, { useContext, useEffect, useState } from "react";
import "./BillingCard.scss";
import AppContext from "../../config/AppContext";
import { LinearProgress, linearProgressClasses } from "@mui/material";
import { sidebarContext } from "../../util/context";
import { listProject } from "../../services/ProjectService";
import { userList } from "../../services/MemberService";
import { ReactComponent as ArrowBackIconBack } from "../../assets/subscription/leftArrow.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const BillingCard = ({ }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await listProject();
        if (res?.data?.code !== "RCE0131") {
          setProjects(res?.data?.data?.totalCount || []);
        } else {
          setProjects([]);
        }
      } catch (error) {
        console.error("Error fetching projects:", error.response || error);
      }
    };
    fetchProjects();
  }, []);

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const res = await userList();
        if (res?.data?.code === "UASI0000") {
          setMembers(res?.data?.data?.totalCount || []);
        } else {
          setMembers([]);
        }
      } catch (error) {
        console.error("Error fetching members:", error.response || error);
      }
    };
    fetchMembers();
  }, []);

  const { mode } = useContext(AppContext);
  const [projects, setProjects] = useState([]);
  const [members, setMembers] = useState([]);
  const { subscriptionDetails } = useContext(sidebarContext);
  const totalPlanPrice = subscriptionDetails?.plan?.price ?? "";
  const memberCount = subscriptionDetails?.features?.find(
    ({ feature }) => feature?.code === "MEMBER_COUNT"
  )?.value;
  const projectCount = subscriptionDetails?.features?.find(
    ({ feature }) => feature?.code === "PROJECT_COUNT"
  )?.value;

  const intervalUnit = subscriptionDetails?.plan?.intervalUnit;
  const billingCycleText = intervalUnit === "years" ? t("RAL0953") : t("RAL0905");
  const perUser = totalPlanPrice / memberCount;
  const userPercentage = (members / memberCount) * 100;
  const projectPercentage = (projects / projectCount) * 100;
  const memberPerCount = memberCount - members;
  const projectPerCount = projectCount - projects;

  return (
    <div className={mode === "dark" ? "billing-cardDark" : "billing-card"}>
      <div className="section-card">
        <div className="titlecontent">
          <span
            className={
              mode === "dark" ? "section-cardTitleDark" : "section-cardTitle"
            }
          >
            {t("RAL0904")}
          </span>
          <span
            className={
              mode === "dark"
                ? "section-cardcontentDark"
                : "section-cardcontent"
            }
          >
            {billingCycleText}
          </span>
        </div>
        <div>
          <span
            className={
              mode === "dark" ? "section-cardpriceDark" : "section-cardprice"
            }
          >
            $ <strong>{Math.floor(perUser)}</strong>
            <span
              className={mode === "dark" ? "decimal-partDark" : "decimal-part"}
            >
              .{String(Math.round((perUser % 1) * 100)).padStart(2, "0")}
            </span>
            <span className={mode === "dark" ? "user-textDark" : "user-text"}>
              {" "}
              /{t("RAL0906")}
            </span>
          </span>
        </div>
      </div>

      <div className="progress-sectionbilling">
        <div>
          <div
            className={
              mode === "dark"
                ? "progress-sectionbillinglabelDark"
                : "progress-sectionbillinglabel"
            }
          >
            <span>
              {members >= memberCount
                ? t("RAL0917")
                : `${memberPerCount} ${t("RAL0918")} ${memberCount} ${t("RAL0919")}`}
            </span>
            <div>
              <span>{userPercentage.toFixed(0)}%</span>
            </div>
          </div>
          <LinearProgress
            variant="determinate"
            value={userPercentage}
            sx={{
              height: 10,
              borderRadius: "2px",
              [`&.${linearProgressClasses.colorPrimary}`]: {
                background: " #EAEBEF 0% 0% no-repeat padding-box",
              },
              [`& .${linearProgressClasses.bar}`]: {
                background:
                  mode === "dark"
                    ? "#6A5FA2 0% 0% no-repeat padding-box;"
                    : "#1D0B77 0% 0% no-repeat padding-box",
                borderRadius: "2px",
              },
            }}
          />
        </div>
        {projectCount > 0 && projectCount !== undefined && (
        <div className="progress-itemBillings">
          <div
            className={
              mode === "dark"
                ? "progress-sectionbillinglabelDark"
                : "progress-sectionbillinglabel"
            }
          >
            <span>
              {projects >= projectCount
                ? t("RAL0920")
                : `${projectPerCount} ${t("RAL0918")} ${projectCount} ${t("RAL0921")}`}
            </span>
            <div>
              <span>{projectPercentage.toFixed(0)}%</span>
            </div>
          </div>
          <LinearProgress
            variant="determinate"
            value={projectPercentage > 100 ?  100 : projectPercentage}
            sx={{
              height: 10,
              borderRadius: "2px",
              [`&.${linearProgressClasses.colorPrimary}`]: {
                background: " #EAEBEF 0% 0% no-repeat padding-box",
              },
              [`& .${linearProgressClasses.bar}`]: {
                background:
                  mode === "dark"
                    ? " #6A5FA2 0% 0% no-repeat padding-box;"
                    : "#1D0B77 0% 0% no-repeat padding-box",
                borderRadius: "2px",
              },
            }}
          />
        </div>
        )}
      </div>
      <div
        className={
          mode === "dark" ? "dividerbillingcarddark" : "dividerbillingcard"
        }
      ></div>
      <div className="Totlebillingsection">
        <div className="totlebillingcomponent">
          <span
            className={
              mode === "dark"
                ? "TotlebillingsectionlabelDark"
                : "Totlebillingsectionlabel"
            }
          >
            {t("RAL0907")}
          </span>
          <span
            className={
              mode === "dark"
                ? "TotlebillingsectionsubtextDark"
                : "Totlebillingsectionsubtext"
            }
          >
            $ {perUser.toFixed(2)} × {memberCount}
          </span>
        </div>
        <div>
          <span
            className={
              mode === "dark" ? "section-cardpriceDark" : "section-cardprice"
            }
          >
            $ <strong>{Math.floor(totalPlanPrice)}</strong>
            <span
              className={mode === "dark" ? "decimal-partDark" : "decimal-part"}
            >
              .{String(Math.round((totalPlanPrice % 1) * 100)).padStart(2, "0")}
            </span>
          </span>

        </div>
      </div>
      {(members >= memberCount || projects >= projectCount) && (
        <div className="billingcardlastsection">
          <div
            className={
              mode === "dark" ? "dividerbillingcard2dark" : "dividerbilling2card"
            }
          ></div>
          <div className={mode === "dark" ? "upgrade-billingplanDark" : "upgrade-billingplan"} onClick={() => navigate("/subscription-manage")}>
            {t("RAL0908")} <ArrowBackIconBack className="keybordiconrotation"  style={{fill: mode === "light" ? "#1D0B77" : "#A49DC8",}} />
          </div>
        </div>
      )}
    </div>
  );
};

export default BillingCard;
